<template>
    <div class="alert-overlay" v-if="is_visible">
        <div class="alert-wrapper" :class=" {
            alert_success: type === 'success',
            alert_error: type === 'error',
            alert_info: type === 'info'
        }">     
                <!-- 提醒類型 -->
                <h2
                    class="alert-title"
                    :class="{
                        alert_success: type === 'success',
                        alert_error: type === 'error',  
                        alert_info: type === 'info'
                    }"      
                >
                    <template>
                        <i 
                            v-if="icon_type === 'success'"
                            class="bi bi-check-circle-fill">
                        </i> 

                        <i 
                            v-else-if="icon_type === 'error'"
                            class="bi bi-exclamation-circle-fill">
                        </i> 

                        <i 
                            v-else-if="icon_type === 'info'"
                            class="bi bi-info-circle-fill">
                        </i> 

                    </template>
                    <span class="text-color-grey" style="color:#2e2e2e;">{{title}}</span>
                </h2>

                <!-- 如果是錯誤類型要顯示的區塊 -->
                <template v-if="type === 'error'" class="text-color-grey">
                    <h6 class="error_code" v-if="error_code">
                        錯誤代碼: {{error_code}}
                    </h6>


                    <h6 class="error_message" v-if="error_message">
                        錯誤訊息: {{error_message}}
                    </h6>
                </template>

                <!-- 內文 -->
                <section class="content text-color-grey" v-if="content">
                    {{content}}
                </section>

                <!-- 錯誤的話要顯示的訊息
                <section class="error_hint" v-if="type === 'error'">
                    <p>請截圖通報程式人員，謝謝。</p>
                </section> -->

                 <!-- 關閉的按鈕 -->
                <section class="button-wrapper">
                    <button v-on:click="is_visible = false">關閉視窗</button>
                </section>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'AlertModal',
        data: function() {
            return {
                is_visible: false,
                title: '',
                type: 'error',
                icon_type: 'error',
                error_code: '',
                error_message: '',
                content:'yo',
            }
        },
        methods: {
            show: function(params) {
                // 訊息框類別
                this.type = params.type

                // 訊息框標題
                this.title = params.title

                // icon 類別
                this.icon_type = params.icon

                // 錯誤代碼(給一般人看的)
                this.error_code = params.error_code

                // 錯誤訊息(給一般人看的)
                this.error_message = params.error_message

                // 自訂內容(放程式exception或自定義的內容)
                this.content = params.content

                this.is_visible = true
            },
            close: function() {
                console.log('close_la')
                this.is_visible = false
            }
        },
        beforeMount() {
        }
    }
</script>

<style>
.alert-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9998;
    top: 0px;
    left: 0px;
    background-color: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    transition:  all .3s;
    animation-name: animatetop;
    animation-duration: 0.2s
}
.alert-wrapper {
    z-index: 9999;
    position: relative;
    background-color: #fff;
    width: 550px;
    border-radius: 5px;
    padding: 2em;
    border-left: 8px #CCC solid;
    text-align: left;
    animation-name: animatetop;
    animation-duration: 0.2s
}
.alert-title {
    text-align: left;
    font-size: 24px;
    margin-bottom: 1em;
}
.alert-title > i {
    margin-right: 0.5em;
}
.content {
    text-align: left;
    margin-bottom: 0.5em;
}
.error_code,.error_message {
    text-align: left;
    color: #46494c ;
    font-weight: bold;
}
.error_hint {
    color: #f53722;
    font-weight: bold;
    text-align: left;
}
.alert_error {
    border-left-color: #f53722;
    color: #f53722;
}
.alert_success {
    color: #1bd73c;
    border-left-color: #1bd73c;
}
.alert_info {
    color: #4385f4;
    border-left-color: #4385f4;
}
.text-color-grey{
    color: #7f8387;
}
.button-wrapper {
    display: flex;
    justify-content: flex-end;
}
.button-wrapper > button {
    outline: none;
    border: 1px #46494c solid;
    border-radius: 16px;
    padding: 5px 10px;
    background: transparent;
    color: #46494c;
    font-size: 14px;
    transition: all .3s;
}
.button-wrapper > button:hover {
    background: #46494c;
    color: #FFF;
}
/* Add Animation */
@keyframes animatetop {
  from {opacity: 0}
  to {opacity: 1}
}
</style>